import {Type} from 'class-transformer';
import {PaginatedResult} from '../PaginatedResult';
import {SimpleTeam} from '../../teams/simple-team';
import {SimpleTeamWithAgentsCount} from '../../teams/simple-team-with-agents-count';

export class PaginatedSimpleTeamsWithAgentsCount extends PaginatedResult {
  @Type(() => SimpleTeamWithAgentsCount)
  public result: Array<SimpleTeamWithAgentsCount>;
}
